import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../../../common/actions';
import {Modal, Button, Table, Loader} from 'semantic-ui-react';
import moment from 'moment';
import {findIndex} from 'lodash';
import './audit.scss';

const dateFormat = 'DD MMM YYYY HH:mm:ss';

class ModalAudit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': false,
    };
    this.onCloseModalClick = this.onCloseModalClick.bind(this);
  }

  render() {
    const {sfx, katashiki} = this.props;
    return (
      <Modal size='fullscreen' onOpen={() => this.fetchData()}
        className='vehicle-master-audit-modal'
        trigger={
          <Button
            primary
            type='submit'
          >
            Auditoría
          </Button>
        } closeIcon>

        <Modal.Header>
          Auditoría del modelo {sfx}/{katashiki}
        </Modal.Header>
        
        <Modal.Content>
          <Modal.Description>
            <div className='table-sticky-header-and-first-column'>
              <Table>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell textAlign='center'>Usuario</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Fecha</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Acción</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Estado de la Solicitud</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Katashiki</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Sufijo Proveedor</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Sufijo TDE</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Descripción</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Aire acondicionado</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Modelo</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Estado del Vehículo</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Tipo de Cabina</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Categoría</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Segmento</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Sub Segmento</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Familia</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Tracción</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Transmisión</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Número de Puertas</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Pasajeros</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Combustible</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>País Origen</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Híbrido</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Clase SRI</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Subclase SRI</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Peso Vacío (Kg)</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Peso Bruto (Kg)</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Volumen (m3)</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Capacidad Carga (Kg)</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Cilindraje (cm3)</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Caballaje (HP)</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Tonelaje (Toneladas)</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Colores Externos</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Colores Internos</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Porcentage ICE Fijo</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Porcentage ICE Variable</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Porcentage IVA</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Precio Venta</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Facturación con IVA</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Partida Arancelaria</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Inen</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>IP</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
            
                <Table.Body>
                  {this.renderData()}
                </Table.Body>
              </Table>
            </div>
          </Modal.Description>
        </Modal.Content>
      </Modal>
    );
  }

  fetchData() {
    const {code} = this.props;
    this.props.fetchVehicleMasterAudit(code);
  }

  onCloseModalClick() {
    this.setState({'modalWasOpen': false});
  }

  renderData() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row className='loader'>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderItems();
  }

  renderItems() {
    const {list, jdeList} = this.props;

    if (!list.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={42}>No hay datos Disponibles</Table.Cell>
        </Table.Row>
      );
    }

    return list.map((element, index) => {
      const dateFormatted = element.date ? moment(element.date).format(dateFormat) : '';
      const dataChanged = element.data;
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.user}</Table.Cell>
          <Table.Cell textAlign='center'>{dateFormatted.toUpperCase()}</Table.Cell>
          <Table.Cell textAlign='center'>{element.action}</Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.state}</Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.katashiki}</Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.sfxProvider}</Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.sfx}</Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.description}</Table.Cell>
          <Table.Cell textAlign='center'>
            {this.getBooleanValuesLabel(dataChanged.airConditioning, 'Si', 'No')}
          </Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.vehicleName}</Table.Cell>
          <Table.Cell textAlign='center'>
            {this.getBooleanValuesLabel(dataChanged.vehicleState, 'Activo', 'Inactivo')}
          </Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.cabinType}</Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.category}</Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.segment}</Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.subSegment}</Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.family}</Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.traction}</Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.transmission}</Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.doorsNumber}</Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.passengers}</Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.fuel}</Table.Cell>
          <Table.Cell textAlign='center'>{this.getNameFromList(jdeList.originsList, dataChanged.country)}</Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.hybrid}</Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.sriClass}</Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.sriType}</Table.Cell>
          <Table.Cell textAlign='right'>{dataChanged.weight}</Table.Cell>
          <Table.Cell textAlign='right'>{dataChanged.wholeWeight}</Table.Cell>
          <Table.Cell textAlign='right'>{dataChanged.volume}</Table.Cell>
          <Table.Cell textAlign='right'>{dataChanged.chargeCapacity}</Table.Cell>
          <Table.Cell textAlign='right'>{dataChanged.cilindraje}</Table.Cell>
          <Table.Cell textAlign='right'>{dataChanged.potency}</Table.Cell>
          <Table.Cell textAlign='right'>{dataChanged.tonnage}</Table.Cell>
          <Table.Cell>
            <ul>{this.getColorsList(dataChanged.colorList, 'outDoorColor', jdeList.outdoorColorList)}</ul>
          </Table.Cell>
          <Table.Cell>
            <ul>{this.getColorsList(dataChanged.colorList, 'inDoorColor', jdeList.indoorColorList)}</ul>
          </Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.ice}</Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.variableIce}</Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.iva}</Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.salesPrice}</Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.ivaInvoicing}</Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.tariffHeading}</Table.Cell>
          <Table.Cell textAlign='center'>{dataChanged.inen}</Table.Cell>
          <Table.Cell textAlign='center'>{element.ip}</Table.Cell>
        </Table.Row>
      );
    });
  }

  getBooleanValuesLabel(value, onLabel, offLabel) {
    if (typeof value === 'undefined') {
      return '';
    }
    if (!value) {
      return offLabel;
    }
    return onLabel;
  }

  getNameFromList(list, name) {
    const index = findIndex(list, {'name': name});
    if (index === -1) {
      return name;
    }
    const description = list[index].description;
    return `${name}-${description}`;
  }

  getColorsList(colorList = [], property, jdeColors) {
    if (!colorList.length) {
      return '';
    }
    return colorList.map((item, index) => {
      const colorsCode = item[property];
      const colorsName = [];
      colorsCode.forEach((code) => {
        colorsName.push(this.getNameFromList(jdeColors, code));
      });
      return <li key={index}>{colorsName.join(', ')}</li>;
    });
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.masterVehicle.loading,
    'list': state.masterVehicle.auditList,
    'jdeList': state.masterVehicle.jdeList,
  };
};

const {
  fetchVehicleMasterAudit,
} = Actions;

export default connect(mapStateToProps, {
  fetchVehicleMasterAudit,
})(ModalAudit);
